import dayjs from 'dayjs';
import React from 'react';
import {loopDates} from '../util/date';
import Config from '../util/config';

export interface Props {
    month: string;
    monthsToDisplay: number;
    onChange: (month: string) => void;
};

const MonthSelect = (props: Props) => {
    const { month } = props;
    const start = dayjs();
    const end = start.clone().add(props.monthsToDisplay, 'months');
    const options: JSX.Element[] = [];

    loopDates(start, end, 'month', (day: dayjs.Dayjs) => {
        options.push(
            <option key={day.format('YYYY-MM')} value={day.format('YYYY-MM')}>
                {day.format('MMMM YYYY')}
            </option>
        );
    });

    const onChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
        props.onChange(evt.target.value);
    };

    const nextMonth = () => {
        const current = dayjs(month, 'YYYY-MM');
        const nextMonth = current.clone().add(1, 'month');

        props.onChange(nextMonth.format('YYYY-MM'));
    }

    const prevMonth = () => {
        const current = dayjs(month, 'YYYY-MM');
        const prevMonth = current.clone().subtract(1, 'month');

        if( dayjs(prevMonth).isSame(dayjs(new Date()), 'month') || dayjs(prevMonth).isAfter(dayjs(new Date()), 'month')){
            props.onChange(prevMonth.format('YYYY-MM'));
        }

    }

    return <div className="month-selector">
        <span
            className="month-selector__arrow month-selector__arrow--prev"
            onClick={prevMonth}
            dangerouslySetInnerHTML={{ __html: Config.get('monthArrowLeft', '<') }}
        />
        <select className="month-selector__select" value={month} onChange={onChange}>
            {options}
        </select>
        <span
            className="month-selector__arrow month-selector__arrow--prev"
            onClick={nextMonth}
            dangerouslySetInnerHTML={{ __html: Config.get('monthArrowRight', '>') }}
        />
    </div>
}

export default MonthSelect;

